<template>
  <div class="homefood">
    <!-- home food mobile web -->
    <b-container v-if="true" fluid style="max-width:1336px;">
      <!-- header -->
      <b-row class="homefood_header_mobile align-items-center">
        <b-col cols="2" @click="menuModal=true" class="text-center">
          <font-awesome-icon style="font-size:22px;" :style="{color:getCssColor('header_icon_color')}" :icon="['fal', 'bars']"/>
        </b-col>
        <b-col class="text-center">
          <img v-if="logo" :src="logo" style="max-height:59px;" />
        </b-col>
        <b-col cols="2" class="text-center">
          <a href="#/cart" aria-label="Cart" style="position:relative;" class="ico" :style="{color: getCssColor('header_icon_color')}">
            <CartBullet style="top:-12px;right:-12px"/>
            <font-awesome-icon style="font-size:22px;" :style="{color:getCssColor('header_icon_color')}" :icon="['fal', 'shopping-cart']"/>
          </a>
        </b-col>
      </b-row>
      <!-- change address -->
      <b-row v-if="$store.state.company.block_address_navigation && $store.state.company.block_address_navigation !== 'NO'" @click="getAddressOrWhere()" class="align-items-center" :style="{backgroundColor: getCssColor('primary_bt')}" style="height:40px;">
        <b-col cols="4" style="padding-right:0px;color:#ffffff;font-weight:bold;font-size:15px;">
          Entregar em: <font-awesome-icon style="font-size:16px;color:#ffffff;" :icon="['fal', 'location']"/>
        </b-col>
        <b-col style="padding-left:0px;padding-right:0px;color:#ffffff;font-weight:300;font-size:15px;">
          {{$store.state.selectedAddressShort}}
           <font-awesome-icon style="float:right;margin-right:8px;font-size:20px;color:#ffffff;" :icon="['fal', 'angle-down']"/>
        </b-col>
       
      </b-row>
      <!-- search area -->
      <b-row class="align-items-center justify-items-center" style="height: 133px;background-size: 100%; background-position: 50%" :style="{'background-image': (banner ? 'url(' + banner + ')' : 'none')}">
        <b-col cols="12" class="text-center">
          <div style="width:295px;margin:16px auto;position:relative;">
            <input @keyup="search()" v-model="$store.state.searchTerm" type="text" placeholder="Qual produto está procurando?" style="color:#333; font-size:16px;width:295px;padding-left:36px;height:35px;background: #ffffff;border-radius: 5px;border:0px;" />
            <font-awesome-icon :style="{color:getCssColor('primary_bt')}" style="position:absolute;left:8px;top:8px;font-size:18px;color:#000000;" :icon="['fal', 'search']"/>
          </div>
        </b-col>
        <b-col cols="12" class="align-self-end" style="z-index:900;">
          <div class="homefood_brandcard" :style="{borderColor:getCssColor('primary_bt')}">
            <span class="homefood_brand" :style="{color:getCssColor('primary_bt')}">{{getChoicedCompany.companyBrand}}</span>
            <ul style="padding:0px;">
              <li style="display:inline;padding:0px;margin:4px;font-size: 10px;">&bull; Frete aprox. R$12,00</li>
              <!--li style="display:inline;padding:0px;margin:4px;font-size: 10px;">&bull; 3km</li-->
              <li style="display:inline;padding:0px;margin:4px;font-size: 10px;">&bull; 40-60 min</li>
            </ul>
          </div>
        </b-col>
      </b-row>
      <!-- info icos area -->
      <b-row class="align-items-center justify-items-center" style="z-index:2000;min-height:83px;box-shadow: 0px -8px 8px rgba(0, 0, 0, 0.3);" :style="{backgroundColor: getCssColor('icon_labels_bg')}">
        <!-- delivery -->
        <b-col cols="4" class="text-center">
          <b-row class="align-items-end justify-items-center" style="height:50%">
            <b-col class="text-center"><font-awesome-icon style="font-size:24px;" :style="{color:getCssColor('icon_labels_icon')}" :icon="['fas', 'shipping-fast']"/></b-col>
          </b-row>
          <b-row class="align-items-center justify-items-center mt-1" >
            <b-col class="text-center homefood_iconlabels_text" :style="{color:getCssColor('icon_labels_font')}">
              <template v-if="getChoicedCompany.delivery_region">
                {{getChoicedCompany.delivery_region}}
              </template>
              <template v-else>
                Entrega Expressa
              </template>
            </b-col>
          </b-row>
        </b-col>
        <!-- lock -->
        <b-col cols="4" class="text-center">
          <b-row class="align-items-end justify-items-center" style="height:50%">
            <b-col class="text-center"><font-awesome-icon style="font-size:24px;" :style="{color:getCssColor('icon_labels_icon')}" :icon="['fas', 'shield-check']"/></b-col>
          </b-row>
          <b-row class="align-items-center justify-items-center mt-1" >
            <b-col class="text-center homefood_iconlabels_text" :style="{color:getCssColor('icon_labels_font')}">
              <template v-if="getChoicedCompany.security_information">
                {{getChoicedCompany.security_information}}
              </template>
              <template v-else>
                Site Seguro
              </template>
            </b-col>
          </b-row>
        </b-col>
        <!-- cards -->
        <b-col cols="4" class="text-center">
          <b-row class="align-items-end justify-items-center" style="height:50%">
            <b-col class="text-center"><font-awesome-icon style="font-size:24px;" :style="{color:getCssColor('icon_labels_icon')}" :icon="['fas', 'credit-card']"/></b-col>
          </b-row>
          <b-row class="align-items-center justify-items-center mt-1" >
            <b-col class="text-center homefood_iconlabels_text" :style="{color:getCssColor('icon_labels_font')}">
              <template v-if="getChoicedCompany.cards_accepted">
                {{getChoicedCompany.cards_accepted}}
              </template>
              <template v-else>
                Aceitamos todos cartões
              </template>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- products lists -->
      <b-row class="mt-3" v-for="(productList, idxPl) in productsList" v-bind:key="idxPl" >
        <b-col cols="12" class="homefood_productlist_title" :style="{color:getCssColor('primary_bt')}">
          {{productList.name}}
        </b-col>
        <b-col cols="12" class="mt-2">
          <div class="homefood_horizontal_list">
            <template v-for="(p, idx) in productList.products">
              <div  v-if="p.product" v-bind:key="idx">
                <div class="product" @click="$router.push({path:'/productfood/'+ p.product.id})">
                  <div class="photo">
                    <div style="width:100%;height:100px;overflow:hidden;border-radius:5px 5px 0 0;" 
                    :style="{backgroundImage:
                      (p.product.photos.length ? 'url(' + productImageURI + '/' + p.product.photos[0].id + ')' : 'none'),
                      backgroundPosition: '50%',
                      backgroundSize: '100%'}"
                      >
                    </div>
                  </div>
                  <div class="name">
                    {{p.product.name}}
                  </div>
                  <div class="price">
                    <template v-if="p.product.product_views[0].promotional_price">
                      de: R$  <span style="text-decoration:line-through;">{{formatPrice(p.product.product_views[0].price)}}</span> por 
                      <b>R$ {{formatPrice(p.product.product_views[0].promotional_price)}}</b>
                    </template>
                    <template v-else>
                      R$ {{formatPrice(p.product.product_views[0].price)}}
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </b-col>
      </b-row>

      <!-- categorias -->
      <b-row class="mb-2 mt-2" style="border-bottom: 1px solid #DADADA;">
        <b-col cols="12" class="homefood_productlist_title" :style="{color:getCssColor('primary_bt')}">
          Categorias
        </b-col>
        <b-col cols="12" class="mt-1 ">
          <div class="homefood_horizontal_categories">
            <div @click="selectCategory(c.id)" v-for="(c, idxc) in categories" v-bind:key="idxc" style="margin-right:16px;">
              <div class="category">
                {{c.name}}
              </div>
              <div class="bullet" :style="{backgroundColor:(currentProds && c.id===currentProds.id ? getCssColor('primary_bt') : '#ffffff')}">
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- produtos -->
      <b-row class="mt-2 mb-2 align-items-center justify-items-center" v-if="currentProds">
        <b-col cols="12" class="homefood_productlist_title mt-2 mb-2" :style="{color:getCssColor('primary_bt')}">
          {{currentProds.name}}
        </b-col>
        <b-col cols="12 mt-2 mb-2 align-self-center" v-for="(pc, idxpc) in currentProds.prods" v-bind:key="idxpc">
         <b-row @click="$router.push({path:'/productfood/'+ pc.id})" class="homefood_product_card align-items-center justify-items-center" style="margin: 0">
          <b-col cols="3" style="height=69px;padding-left:8px;">
            <div class="photo"  :style="{backgroundImage:getProdCardUri(pc)}" ></div>
          </b-col>
          <b-col>
            <b-row style="height:33px;">
              <b-col cols="7" class="title">{{pc.name}}</b-col>
              <b-col cols="5" class="price text-right">
                <template v-if="pc.product_views[0].promotional_price">
                  <div style="font-size:12px;line-height:14px;font-weight:normal;margin-top:-4px;">
                  de: R$ <span style="text-decoration:line-through">{{formatPrice(pc.product_views[0].price)}}</span><br/>
                  <span style="font-weight:bold;"> por: R$ {{formatPrice(pc.product_views[0].promotional_price)}}</span>
                  </div>
                </template>
                <template v-else>
                  R$ {{formatPrice(pc.product_views[0].price)}}
                </template>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="description" v-html="pc.description"></b-col>
            </b-row>
          </b-col>
         </b-row>
       </b-col> 
      </b-row>

    </b-container>
    <!-- -->


    <!-- home food desktop -->
    <b-container v-else>

    </b-container>
    <!-- -->

    <Footer/>

    <!-- menu -->
    <OpaSlideModal 
      title="" 
      direction="left" 
      v-model="menuModal"
      @slideModalClose="() => menuModal = false"
      >
      <div style="overflow-y:auto;overflow-x:hidden;height:calc(100vh - 56px)">

        <b-row v-if="!$store.state.user" class="text-center mt-4">
          <b-col>
            <button class="solid" @click="doEnterOrRegister()" :style="{backgroundColor:getCssColor('primary_bt')}">
              Entrar ou Cadastrar
            </button>
          </b-col>
        </b-row>
        <b-row v-else class="text-center mt-4">
          <b-col class= "text-center" @click="$router.push({path:'/profile'})" >
            <div style="margin:0px auto;margin-bottom:8px;background-color:#F1F1F1;width:118px;height:118px;border-radius:59px;" :style="{'border':'3px solid ' + getCssColor('primary_bt')}">
              <font-awesome-icon style="font-size:56px;margin-right:3px;margin-top:28px;color:#ffffff;" :icon="['far', 'user']"/>
            </div>
            <div :style="{color:getCssColor('primary_bt')}" style="font-size:18px;font-weight:500;">
              {{$store.state.user.name}} {{$store.state.user.familyName}}
              <font-awesome-icon style="font-size:22px;margin-left:8px;" :icon="['far', 'edit']"/>  
            </div>
          </b-col>
        </b-row>

        <MenuLinks class="mt-4" />

        <b-row v-if="$store.state.user" style="height:4px;" class="text-center mt-4">
          <b-col >
            <button class="solid" @click="doLogout()" :style="{backgroundColor:getCssColor('primary_bt')}">
              Sair ou entrar em outra conta
            </button>
          </b-col>
        </b-row>


      </div>
    </OpaSlideModal>

    <!-- enter or register -->
    <EnterOrRegister v-model="enterRegisterModal" @loginRegisterLogged="() => loggedIn" @slideModalChange="(val) => enterRegisterModal = val"/>

    <!-- component of consumer location -->
    <WhereAreYou v-model="whereAreYouModal" @slideModalChange="(val) => whereAreYouModal = val" @continueWithAddress="(latLong) => continueWithAddress(latLong)" />
  </div>
</template>

<script>
import colors from '@/mixins/colors'
import cartMixin from '@/mixins/cartMixin'
import formaters from '@/mixins/formaters'
import { EventBus } from '@/behaviours/event-bus'
import WhereAreYou from  '@/components/WhereAreYou'
import LocationConn from '@/connection/location'
import ProductsConn from '@/connection/productsv2.js'
import CategoryConn from '@/connection/categories.js'
import OpaSlideModal from '@/components/OpaSlideModal'
import CartBullet from '@/components/CartBullet'
import MenuLinks from '@/components/MenuLinks'
import { mapGetters } from 'vuex'
import Footer from '@/components/Footer'
import UserConn from "@/connection/user"
import EnterOrRegister from '@/components/EnterOrRegister'

export default {

  data () {
    return {
      whereAreYouModal: false,
      enterRegisterModal: false,

      banners: [],
      productsList: [],
      categories: [],
      prodCategory: [],
      currentProds: null,
      menuModal: false,

      loadingCategories: true,
      loadingLists: true
    }
  },

  mixins:[colors, cartMixin, formaters],

  components: {WhereAreYou, Footer, OpaSlideModal, MenuLinks, CartBullet, EnterOrRegister},

  computed: {

    ...mapGetters(['getChoiceCompanyId', 'getChoicedCompany']),

    logo () {
      if (!this.getChoicedCompany.logo) {
        return null
      } else if (!this.getChoicedCompany.logo_header) {
        return this.getChoicedCompany.logo
      } else {
        return this.getChoicedCompany.logo_header
      }
    },

    productImageURI () {
      return 'https://cdnimages.opa4.store/productImages'
    },

    banner () {
      if (this.banners.length) {
        if (this.$mq === 'mobile' && this.banners[0].xs_url) {
          return 'https://cdnimages.opa4.store/img/' + this.getChoiceCompanyId + '/banner/' + this.banners[0].xs_url
        } else if (this.$mq === 'tablet' && this.banners[0].sm_url) {
          return 'https://cdnimages.opa4.store/img/' + this.getChoiceCompanyId + '/banner/' +  this.banners[0].sm_url
        } else if (this.banners[0].md_url) {
          return 'https://cdnimages.opa4.store/img/' + this.getChoiceCompanyId + '/banner/' +  this.banners[0].md_url
        } else {
          return null
        }
      } else {
        return null
      }
    }
  },

  async mounted () {
    await this.clearHome()
  }, 

  methods: {

    async loggedIn () {
      this.menuModal = false
    },

    doEnterOrRegister () {
      this.enterRegisterModal = true
    },

    doLogout() {
      UserConn.logout()
      this.$store.state.choicedCompanyId = null
      this.$store.state.choicedCompany = null
      this.$store.state.selectedAddressShort = null
      location.reload()
    },

    search () {
      this.$store.state.activeSearch = true
      this.$router.push({path:'/search'})
    },

    getAddressOrWhere () {
      this.whereAreYouModal = true
    },

    getProdCardUri (product) {
      if (product.photos.length && product.photos[0].id) {
        return 'url(' + this.productImageURI + '/' + product.photos[0].id + ')'
      } else {
        return 'none'
      }
    },

    async clearHome () {
      this.banners = this.getChoicedCompany.banners
      
      await ProductsConn.getProductsIndex()
      let productsListData = await ProductsConn.getAllProductList()
      this.productsList = productsListData.data
      console.log('choice company', this.getChoicedCompany)
      this.$store.state.showLoading = false
      this.whereAreYouModal = false

      await this.getCategoriesAndProducts()

      this.$forceUpdate()
      console.log('currentProds', this.currentProds)
    },

    async getCategoriesAndProducts () {
      let cats = await CategoryConn.getAll(this.$store.getters.getChoicedCompany.companyId)
      console.log(cats.data)
      this.loadingCategories = false
      if (!cats.error && cats.data) {
        this.categories = cats.data //.splice(0,5)
        this.prodCategory = []
        let count = 0
        this.categories.forEach(async (cat) => {
          let prods = await ProductsConn.getAllProductsByCategoryId(cat.id, 100)
          //consider or not stock in DB
          if (this.$store.getters.getChoicedCompany.stock_configuration === true) {
            prods = prods.filter(p => p.active && p.product_views[0].stock_quantity > 0)
          } else {
            prods = prods.filter(p => p.active === true)
          }
          prods.sort((a, b) => a.order - b.order)
          this.loadingLists = false
          if (!prods.error && prods.length) {
            this.prodCategory.push({
              name: cat.name,
              prods: prods,
              id: cat.id
            })
          }
          count++
          if (count === this.categories.length){
            this.selectCategory(this.categories[0].id)
          }
        })
        console.log('finish loading lists')
      } else {
        EventBus.$emit('showAlert', 'error', 'Erro ao obter dados da loja.')
      }
    },

    selectCategory (id) {
      let pc = this.prodCategory.filter(pc => pc.id === id)
      if (pc.length) {
        this.currentProds = pc[0]
        this.$forceUpdate()
      }
    },

    async continueWithAddress (latLong) {
      if (this.$store.state.company.block_address_navigation === "YES_LIST") {
        this.$router.push({path: '/company_list/' + this.$store.state.lastLatLongUri})
      } else {
        let result = await LocationConn.getCompaniesByLocation(latLong.lat, latLong.lng)
        if (!result.error){
          let companies = result
          if (companies.length) {
            let company = companies[companies.length-1]
            this.$store.commit('setChoicedCompanyId', company.companyId)
            this.$store.commit('setChoicedCompany', company)
            this.clearHome()
          } else {
            // no companies
            this.$router.push({path: '/company_list/' + this.$store.state.lastLatLongUri})
          }
        } else {
          EventBus.$emit('showAlert', 'error', result.msg)
        }
      }
    },
  }

}
</script>

<style lang="scss">
.homefood {
  min-height: 100vh;
}
// mobile
.homefood_header_mobile {
  height: 120px;
  background-color: #ffffff;
}

.homefood_iconlabels_text {
  font-size:10px;
  color: #ffffff;
  font-weight: 500;
  line-height:10px;
}

.homefood_productlist_title {
font-size: 16px;
line-height: 20px;
font-weight: bold;
}

.homefood_horizontal_categories {
  width:100%;
  height:40px;
  overflow-x:auto;
  -webkit-overflow-scrolling: touch;
  overflow-y:hidden;
  padding:5px 0;
  display:flex;
  margin-top:8px;

  .category {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #737373;
    padding: 0 16px;
    text-align:center;
    white-space: nowrap;
  }

  .bullet {
    width:100%;
    height:4px;
    margin-top:4px;
  }
}

.homefood_product_card {
  height:90px;
  background: #FBFBFB;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
  border-radius: 5px;

  .photo {
    width: 69px;
    height:69px;
    background: #ffffff;
    border-radius: 5px;
    overflow:hidden;
    background-size:100%;
    background-position: center;
    background-repeat:no-repeat;
  }

  .title {
    height:30px;
    font-size: 15px;
    line-height:15px;
    overflow:hidden;
    text-overflow: ellipsis;
    color: #000000;
    padding:0px;
    margin-top:8px;
  }

  .price {
    font-size: 15px;
    line-height:15px;
    color: #000000;
    padding:0px;
    padding-right:8px;
    margin-top:8px;
  }

  .description {
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    color: #000000;
    overflow:hidden;
    text-overflow: ellipsis;
    height: 35px;
    margin-top:8px;
    padding:0 8px;
    padding-left:0px;
  }
}

.homefood_horizontal_list {
  width:100%;
  height:190px;
  overflow-x:auto;
  -webkit-overflow-scrolling: touch;
  overflow-y:hidden;
  padding:5px 0;
 border-radius: 5px;
  display:flex;

  .product {
    width: 194px;
    height:160px;
    background: #FFFFFF;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    margin-right: 16px;
    border-radius: 5px;

    .photo {
      min-width:100%;
      max-width:100%;
      border-radius: 5px;
    }

    .name {
      font-size: 11px;
      color: #000000;
      padding:6px;
      line-height:12px;
      height:29px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .price {
      font-size: 12px;
      padding:5px;
      color: #525962
    }
  }

  .product:first-child {
    margin-left:2px;
  }

}

.homefood_brand {
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
}

.homefood_brandcard {
  text-align:center;
  padding:4px 8px;
  background-color:#ffffff;
  margin:0px auto;
  width:266px;
  height:64px;
  border-radius:30px 30px 0px 0px;
  border: 2px solid;
  box-shadow: inset 0px -8px 8px rgba(0, 0, 0, 0.15);
}

//desktop
</style>
